import React from 'react';
function LifeBuoy({ size, stroke = 'currentColor', ...otherProps }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke={stroke}
      {...otherProps}
    >
      <path strokeLinecap="round" strokeLinejoin="round" d="M12 21a9 9 0 100-18 9 9 0 000 18z" />
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M12 16a4 4 0 100-8 4 4 0 000 8zM6 6l3 3M15 15l3 3M15 9l3-3M15 9l3-3M6 18l3-3"
      />
    </svg>
  );
}

export default LifeBuoy;
